module.exports = __webpack_public_path__ + "img/7.f571c04d.jpg";